module.exports = __webpack_public_path__ + "img/08.fffd24ef.jpg";